import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import querystring from "querystring";
import { loginFromMedproId, logOut } from "~/store/user/userAction";
import { client } from "~/utils/medproSDK";
import { handleClearAndLogout } from "~/api/axios.config";
import { setKeyCookie } from "~/utils/func";

class AuthorizedPage extends React.Component {
  constructor(props) {
    super(props);
    const params = window.location.pathname.split("/")[2];
    const parse = querystring.parse(params);

    const checkAuth = async () => {
      try {
        const response = await client.authorizeRedirectToken({
          token: parse.token
        });
        const { token, refreshToken } = response.data;
        client.setToken(token);

        setKeyCookie("token", token);

        setKeyCookie("refreshToken", refreshToken);

        this.props.loginFromMedproId({ token });
      } catch (error) {
        handleClearAndLogout(this.props.logOut());
      }
    };

    checkAuth();
  }

  componentDidUpdate(prevProps) {
    const { history, IsAuthenticated, currentUrl } = this.props;
    const loginAt = window.localStorage.getItem("loginAt") || "/";

    if (IsAuthenticated && !prevProps.IsAuthenticated) {
      history.push(loginAt || currentUrl);
    } else {
      history.push("/");
    }
  }

  render() {
    return <div>{}</div>;
  }
}

const mapStateToProps = state => {
  const {
    user: { IsAuthenticated },
    login: { currentUrl }
  } = state;
  return {
    IsAuthenticated,
    currentUrl
  };
};

export default connect(mapStateToProps, { loginFromMedproId, logOut })(
  withRouter(AuthorizedPage)
);
